import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {roomChatBotService} from "@/core/service/room.chatBot.service";

class RoomChatBotApi extends BaseApi {
    constructor() {
        super()
        Room.ChatBot = this

        Room.ready(async e => {
            this._eventListen(this.#Events)
        })
    }

    #Events = {
        room_chatBot_text(e) {
            Room.emit(e);
        },
        room_chatBot_text_stream(e) {
            Room.emit(e);
        }
    }

    async sendChatMessage(data) {
        await roomChatBotService.sendChatMessage(data)
    }
}

export const RoomChatBot = new RoomChatBotApi()